import { render, staticRenderFns } from "./drugCompaniesHome.vue?vue&type=template&id=7579defa&scoped=true"
import script from "./drugCompaniesHome.vue?vue&type=script&lang=js"
export * from "./drugCompaniesHome.vue?vue&type=script&lang=js"
import style0 from "./drugCompaniesHome.vue?vue&type=style&index=0&id=7579defa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7579defa",
  null
  
)

export default component.exports